import axios from '@/libs/api.request'

export const getPlayPromotionCoverPage = (params) => {
  return axios.request({
    method: 'get',
    url: '/play/promotion/cover/page',
    params
  })
}

export const addPlayPromotionCover = (data) => {
  return axios.request({
    method: 'post',
    url: '/play/promotion/cover',
    data
  })
}

export const editPlayPromotionCover = (data) => {
  return axios.request({
    method: 'put',
    url: '/play/promotion/cover',
    data
  })
}

export const batchAddPlayPromotionCover = (data) => {
  return axios.request({
    method: 'post',
    url: '/play/promotion/cover/batch/add',
    data
  })
}

export const batchEditPlayPromotionCover = (data) => {
  return axios.request({
    method: 'post',
    url: '/play/promotion/cover/batch/edit',
    data
  })
}

export const deletePlayPromotionCover = (id) => {
  return axios.request({
    method: 'delete',
    url: '/play/promotion/cover/' + id
  })
}

export const usePlayPromotionCover = (id) => {
  return axios.request({
    method: 'get',
    url: '/play/promotion/cover/use/' + id
  })
}
